import { useState } from 'react';
import { INLINE_IDS, ATTACHMENT_IDS } from './fixtures';
import { loadDraft, resolveStorage, resolveDraftLock, withDraftLock, type Snapshot, type DraftLockManager } from './model';
import { recoveryEntries, preserveAndApply, type RecoveryEntry } from './quiz-draft';

export function QuizRecovery({snapshot,enabled}: {snapshot:Snapshot;enabled:boolean}) {
  const [entries,setEntries]=useState<RecoveryEntry[]>([]);
  const [selected,setSelected]=useState('');
  const [message,setMessage]=useState('');
  const [busy,setBusy]=useState(false);
  function read() {
    try {setEntries(recoveryEntries(resolveStorage(()=>localStorage)).slice().reverse());}
    catch(e){setMessage(e instanceof Error?e.message:'Recovery copies could not be read.');}
  }
  async function restore() {
    setBusy(true);setMessage('');
    const storage=resolveStorage(()=>localStorage),locks=resolveDraftLock(()=>navigator.locks as unknown as DraftLockManager);
    const result=await withDraftLock(locks,()=>{
      try {
        const current=loadDraft(storage,INLINE_IDS,ATTACHMENT_IDS),previous=loadDraft(storage,INLINE_IDS,ATTACHMENT_IDS,selected);
        if(current.status!=='loaded'||previous.status!=='loaded'||!recoveryEntries(storage).some(e=>e.key===selected)) throw new Error('This saved design cannot be restored right now.');
        if(JSON.stringify(current.snapshot)!==JSON.stringify(snapshot)) throw new Error('Your draft changed or is still saving. Reopen Previous designs and try again.');
        preserveAndApply(storage,previous.snapshot,current.revision,crypto.randomUUID(),INLINE_IDS,ATTACHMENT_IDS,crypto.randomUUID());
        return {ok:true as const};
      } catch(e){return {ok:false as const,message:e instanceof Error?e.message:'The draft was not changed.'};}
    },'gbm-studio-draft-v1');
    if(result.ok && result.value.ok) {window.location.reload();return;}
    setMessage(!result.ok?result.message:!result.value.ok?result.value.message:'');setBusy(false);
  }
  return <details onToggle={e=>{if(e.currentTarget.open)read();}}><summary>Previous designs on this browser</summary>
    <p>Original designs kept before applying a quiz result. Restoring one also keeps a copy of your current saved design.</p>
    {entries.length ? <><label>Previous design<select value={selected} onChange={e=>{setSelected(e.target.value);setMessage('');}}><option value="">Choose a saved design</option>{entries.map(e=><option key={e.key} value={e.key}>{new Date(e.savedAt).toLocaleString()} · {e.recipient==='gift'?'Gift':'For myself'} · {e.pieces} pieces</option>)}</select></label><button disabled={!selected||busy||!enabled} onClick={()=>void restore()}>Restore selected design</button></> : <p>No previous quiz designs saved on this browser.</p>}
    {!enabled && <p>Resume browser saving before restoring a previous design.</p>}
    {message && <p role="alert">{message}</p>}
  </details>;
}
